import { useEffect, useState } from 'react';

/**
 * Tracks the window's scroll offset and its height together, because every scroll-driven
 * effect on this site is paced in viewport heights rather than pixels.
 */
export default function useScrollProgress() {
    const [scrollY, setScrollY] = useState(0);
    const [viewportHeight, setViewportHeight] = useState(800);

    useEffect(() => {
        const update = () => {
            setScrollY(window.scrollY);
            setViewportHeight(window.innerHeight);
        };
        update();
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        return () => {
            window.removeEventListener('scroll', update);
            window.removeEventListener('resize', update);
        };
    }, []);

    return { scrollY, viewportHeight };
}
